import React, { useCallback, useEffect } from 'react'
import PageHeader from 'App/components/PageHeader'
import { makeStyles } from '@material-ui/core/styles'
import AddIcon from '@material-ui/icons/Add'
import ContainedButton from 'civic-champs-shared/core/ContainedButton'
import { DailyEventsTable } from 'Event/components/DailyEventsTable'
import { useEventsPageState } from 'Event/hooks/useEventsPageState'
import { EventPages } from 'Event/redux/actions/EventNavigation'
import OngoingOpportunitiesTable from 'Event/components/OngoingOpportunitiesTable'
import { useShowEventAddEditPrompt } from 'Event/hooks/useShowEventAddEditPrompt'
import { OpportunityResponse } from 'Event/interfaces/interfaceCreateEditEvent'
import { encodeOccurrenceFromEvent } from 'Event/helpers/encodeOccurrence'
import { useHistory } from 'react-router'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { useFeatureEnabled } from '../../core/feature/hooks'
import { useShowAddEditOfferPrompt } from '../hooks/useShowAddEditOfferPrompt'
import { OutlinedButton } from '../../civic-champs-shared'

const useStyles = makeStyles({
  tables: {
    display: 'flex',
    flexDirection: 'column',
    gap: '35px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '20px',
  },
})

export const ListOfEventsComponent = () => {
  const history = useHistory()
  const offersEnabled = useFeatureEnabled('StandaloneOffers')
  const newEventEditUIEnabled = useFeatureEnabled('NewEditEventUICalendarEvent')
  const currentOrg = useCurrentOrg()
  const onSuccess = useCallback(
    (event: OpportunityResponse) => {
      let url: string
      if (event.isOffer) {
        url = `/offers/${encodeOccurrenceFromEvent(event)}`
      } else {
        url = event.schedulable
          ? `/events/${encodeOccurrenceFromEvent(event)}/${currentOrg.id}`
          : `/opportunities/${encodeOccurrenceFromEvent(event)}`
      }
      history.push(url)
    },
    [currentOrg.id, history],
  )
  const showOpportunityPrompt = useShowEventAddEditPrompt(onSuccess)
  const showOfferPrompt = useShowAddEditOfferPrompt(onSuccess)
  const classes = useStyles()
  const [, setEventsPage] = useEventsPageState()
  useEffect(() => {
    setEventsPage(EventPages.List)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  let offersHeaderButtons: React.ReactElement | undefined
  if (offersEnabled) {
    if (newEventEditUIEnabled) {
      offersHeaderButtons = (
        <div className={classes.buttons}>
          <OutlinedButton startIcon={<AddIcon />} onClick={() => showOfferPrompt()}>
            Add Offer
          </OutlinedButton>
          <ContainedButton startIcon={<AddIcon />} onClick={() => showOpportunityPrompt()}>
            Add Event
          </ContainedButton>
        </div>
      )
    } else {
      offersHeaderButtons = (
        <ContainedButton startIcon={<AddIcon />} onClick={() => showOfferPrompt()}>
          Add Offer
        </ContainedButton>
      )
    }
  } else {
    offersHeaderButtons = (
      <ContainedButton startIcon={<AddIcon />} onClick={() => showOpportunityPrompt()}>
        Add Opportunity
      </ContainedButton>
    )
  }

  return (
    <div className={classes.container}>
      <div className={classes.tables}>
        <OngoingOpportunitiesTable headerButtons={offersHeaderButtons} />
        <DailyEventsTable />
      </div>
    </div>
  )
}

export const ListOfEvents = () => {
  return (
    <PageHeader title="List of Events" subTitle="Create and manage your organization’s events">
      <ListOfEventsComponent />
    </PageHeader>
  )
}

export default ListOfEvents
